/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoCustomerNumber } from './HeoCustomerNumber';
import {
    HeoCustomerNumberFromJSON,
    HeoCustomerNumberFromJSONTyped,
    HeoCustomerNumberToJSON,
    HeoCustomerNumberToJSONTyped,
} from './HeoCustomerNumber';
import type { Street } from './Street';
import {
    StreetFromJSON,
    StreetFromJSONTyped,
    StreetToJSON,
    StreetToJSONTyped,
} from './Street';
import type { HeoAddressNumber } from './HeoAddressNumber';
import {
    HeoAddressNumberFromJSON,
    HeoAddressNumberFromJSONTyped,
    HeoAddressNumberToJSON,
    HeoAddressNumberToJSONTyped,
} from './HeoAddressNumber';

/**
 * 
 * @export
 * @interface RetailerAddress
 */
export interface RetailerAddress {
    /**
     * 
     * @type {string}
     * @memberof RetailerAddress
     */
    id: string;
    /**
     * 
     * @type {RetailerAddressTypeEnum}
     * @memberof RetailerAddress
     */
    type: RetailerAddressTypeEnum;
    /**
     * 
     * @type {HeoCustomerNumber}
     * @memberof RetailerAddress
     */
    customerNumber: HeoCustomerNumber;
    /**
     * 
     * @type {HeoAddressNumber}
     * @memberof RetailerAddress
     */
    addressNumber: HeoAddressNumber;
    /**
     * 
     * @type {string}
     * @memberof RetailerAddress
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerAddress
     */
    additionalInfo: string;
    /**
     * 
     * @type {Street}
     * @memberof RetailerAddress
     */
    street: Street;
    /**
     * 
     * @type {string}
     * @memberof RetailerAddress
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerAddress
     */
    countryIso2: string;
    /**
     * 
     * @type {boolean}
     * @memberof RetailerAddress
     */
    isActiveAddress: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RetailerAddress
     */
    lastSyncedAt: Date;
}


/**
 * @export
 */
export const RetailerAddressTypeEnum = {
    Shipping: 'SHIPPING'
} as const;
export type RetailerAddressTypeEnum = typeof RetailerAddressTypeEnum[keyof typeof RetailerAddressTypeEnum];


/**
 * Check if a given object implements the RetailerAddress interface.
 */
export function instanceOfRetailerAddress(value: object): value is RetailerAddress {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('customerNumber' in value) || value['customerNumber'] === undefined) return false;
    if (!('addressNumber' in value) || value['addressNumber'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('additionalInfo' in value) || value['additionalInfo'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('countryIso2' in value) || value['countryIso2'] === undefined) return false;
    if (!('isActiveAddress' in value) || value['isActiveAddress'] === undefined) return false;
    if (!('lastSyncedAt' in value) || value['lastSyncedAt'] === undefined) return false;
    return true;
}

export function RetailerAddressFromJSON(json: any): RetailerAddress {
    return RetailerAddressFromJSONTyped(json, false);
}

export function RetailerAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetailerAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'customerNumber': HeoCustomerNumberFromJSON(json['customerNumber']),
        'addressNumber': HeoAddressNumberFromJSON(json['addressNumber']),
        'name': json['name'],
        'additionalInfo': json['additionalInfo'],
        'street': StreetFromJSON(json['street']),
        'zipCode': json['zipCode'],
        'city': json['city'],
        'countryIso2': json['countryIso2'],
        'isActiveAddress': json['isActiveAddress'],
        'lastSyncedAt': (new Date(json['lastSyncedAt'])),
    };
}

export function RetailerAddressToJSON(json: any): RetailerAddress {
    return RetailerAddressToJSONTyped(json, false);
}

export function RetailerAddressToJSONTyped(value?: RetailerAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'customerNumber': HeoCustomerNumberToJSON(value['customerNumber']),
        'addressNumber': HeoAddressNumberToJSON(value['addressNumber']),
        'name': value['name'],
        'additionalInfo': value['additionalInfo'],
        'street': StreetToJSON(value['street']),
        'zipCode': value['zipCode'],
        'city': value['city'],
        'countryIso2': value['countryIso2'],
        'isActiveAddress': value['isActiveAddress'],
        'lastSyncedAt': value['lastSyncedAt'].toISOString(),
    };
}

